import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const distribution = {
  fetchDistributionList: lazyModuleMethod(
    () => import('./fetchDistributionList'),
    'default'
  ),
  fetchDistributionWeekList: lazyModuleMethod(
    () => import('./fetchDistibutionWeekList'),
    'default'
  ),
}
